import { render } from "./WaiverReverted.vue?vue&type=template&id=22420fe2"
import script from "./WaiverReverted.vue?vue&type=script&lang=js"
export * from "./WaiverReverted.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__